import { useEffect, useState } from 'react'
import { IInputFieldState, TInputFieldHook } from 'models/inputField.model'
import { EMAIL_REGEXP } from 'root-constants'
import { useTranslation } from 'react-i18next'

export const useEmailInputField = (
  errorMessage?: string | null,
  resetErrorMessage?: () => void,
): TInputFieldHook => {
  const { t } = useTranslation()
  const [email, setEmail] = useState<IInputFieldState>({
    value: '',
    isValid: false,
    isFocused: false,
    validationText: '',
    firebaseError: '',
  })

  useEffect(() => {
    if (!EMAIL_REGEXP.test(email.value)) {
      setEmail((prevState) => ({
        ...prevState,
        isValid: false,
        firebaseError: '',
      }))
      return
    }

    setEmail((prevState) => ({
      ...prevState,
      isValid: true,
      firebaseError: '',
    }))
  }, [email.value])

  useEffect(() => {
    setEmail((prevState) => ({
      ...prevState,
      validationText:
        email.value && !email.isValid && !email.isFocused
          ? t`login.invalidEmail`
          : '',
    }))
  }, [email.value, email.isValid, email.isFocused, t])

  useEffect(() => {
    if (errorMessage) {
      setEmail((prevState) => ({
        ...prevState,
        isValid: false,
        firebaseError: errorMessage,
      }))

      resetErrorMessage && resetErrorMessage()
    }
  }, [errorMessage, resetErrorMessage])

  return [email, setEmail]
}
